import { useNavigate } from "react-router-dom";

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <div className="h-screen w-full flex flex-col items-center justify-center bg-white">
      {/* Number 404 */}
      <div className="text-[200px] font-bold text-[#4D88FF]/10 leading-none select-none">
        404
      </div>

      {/* Content Container */}
      <div className="absolute flex flex-col items-center">
        {/* Icon */}
        <div className="mb-4">
          <svg
            className="w-24 h-24 text-[#4D88FF]"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </div>

        {/* Text Content */}
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-gray-800 mb-2">
            ¡Página no encontrada!
          </h1>
          <p className="text-gray-600 max-w-md">
            Lo sentimos, la página que estás buscando no existe o ha sido movida
            a otra ubicación.
          </p>
        </div>

        {/* Button */}
        <button
          onClick={() => navigate("/")}
          className="px-8 py-3 bg-[#4D88FF] text-white rounded-full font-semibold
                     hover:bg-[#4D88FF]/90 transition-colors duration-200
                     focus:outline-none focus:ring-2 focus:ring-[#4D88FF]/50 focus:ring-offset-2"
        >
          Back to Home
        </button>
      </div>
    </div>
  );
};

export default NotFoundPage;
